// extracted by mini-css-extract-plugin
module.exports = {"upsellCard":"upsellCard__rHC2v","title":"title__djuQn","description":"description__gwSfC","actions":"actions__0y3U3"};